var _circle, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#ECF9FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29652_4283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0175 12.1315C26.1306 11.7921 26.0423 11.4178 25.7892 11.1648C25.5362 10.9118 25.162 10.8234 24.8225 10.9366L10.7947 15.6125C10.4393 15.731 10.1875 16.0483 10.1528 16.4213C10.1182 16.7943 10.3072 17.1526 10.6347 17.3345L14.9289 19.7202C15.2976 19.925 15.7574 19.8606 16.0557 19.5624L19.1093 16.5087C19.4783 16.1398 20.0764 16.1398 20.4453 16.5087C20.8142 16.8776 20.8142 17.4758 20.4453 17.8447L17.3916 20.8984C17.0934 21.1966 17.029 21.6564 17.2338 22.0251L19.6195 26.3194C19.8015 26.6468 20.1597 26.8359 20.5327 26.8012C20.9058 26.7665 21.2231 26.5147 21.3415 26.1593L26.0175 12.1315Z",
    fill: "#4FC0CF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.218 23.5438C10.1852 23.5369 10.1566 23.5155 10.1395 23.4805C10.1025 23.4047 10.1321 23.2938 10.2061 23.2329L12.7418 21.1392C12.8158 21.0783 12.9059 21.09 12.9429 21.1658C12.98 21.2417 12.9503 21.3526 12.8549 21.4061L10.3192 23.4997C10.3007 23.5399 10.2564 23.5518 10.218 23.5438Z",
    fill: "#7ED957",
    stroke: "#7ED957",
    strokeWidth: 1.56667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2646 27.6483C11.2127 27.6413 11.1665 27.6104 11.1371 27.5562C11.0737 27.4385 11.1122 27.2556 11.2236 27.1477L15.042 23.4407C15.1535 23.3328 15.2953 23.3401 15.3587 23.4578C15.4222 23.5755 15.3837 23.7584 15.2382 23.8571L11.4198 27.5641C11.3938 27.6313 11.3252 27.6562 11.2646 27.6483Z",
    fill: "#7ED957",
    stroke: "#7ED957",
    strokeWidth: 1.56667,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29652_4283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8936,
    height: 18.8936,
    fill: "white",
    transform: "translate(20.4453 3.14893) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralShareIcon);
export default __webpack_public_path__ + "static/media/referral-share-icon.27a0d7a54d0d3c226dc40c3007b40a60.svg";
export { ForwardRef as ReactComponent };